<template>
  <BlockClickable
    tagName="div"
    type="onestoreSubscribeItem"
    :active="!isExpire"
    @click="goDetail"
  >
    <div class="onestore-subscribe-title-wrap">
      <Mark type="subscribeItemTitle" :active="!isExpire">{{
        productName
      }}</Mark>
      <Icon type="subscribeItemGoDetail" v-if="!isExpire"></Icon>
    </div>
    <div class="onestore-subscribe-content-wrap">
      <div class="sub-ico-wrap">
        <img :src="icon" />
      </div>
      <div class="sub-content-wrap">
        <Mark type="subscribeItemContent" :active="!isExpire">{{
          productDesc
        }}</Mark>
        <!-- 未到期且没有取消，则提示续期日期 -->
        <Mark
          type="subscribeItemTime"
          :active="!isExpire"
          v-if="!isExpire && !isCancel"
          >{{
            replaceDateAndPricesOfText({
              date: expiredTime,
              text: languages.onestore_subscribe_goon_sub,
            })
          }}</Mark
        >
        <!-- 已过期或未到期但取消了，则提示到期日期 -->
        <Mark type="subscribeItemTime" :active="!isExpire" v-else>{{
          replaceDateAndPricesOfText({
            date: expiredTime,
            text: languages.onestore_subscribe_expire_time,
          })
        }}</Mark>
      </div>
    </div>
  </BlockClickable>
</template>
<script>
import { UPDATE_NOW_VALID_ITEM_INDEX } from '@store/passport/onestoreSubscribe';
import { replaceDateAndPricesOfText } from '@utiles/index';
import { mapState } from 'vuex';
export default {
  props: [
    'id',
    'index',
    'productName',
    'productDesc',
    'expiredTime',
    'icon',
    'prices',
    'orderId',
    'productId',
    'isExpire',
    'isCancel',
  ],
  computed: {
    ...mapState({
      languages: state => state.onestoreSubscribe.languages,
    }),
  },
  methods: {
    updateNowValidItemIndex(index) {
      this.$store.commit(UPDATE_NOW_VALID_ITEM_INDEX, index);
    },
    goDetail() {
      if (this.isExpire) {
        return;
      }
      this.updateNowValidItemIndex(this.index);
      this.$router.push('/onestoreSubscribe/detail');
    },
    replaceDateAndPricesOfText,
  },
};
</script>
